import React, { useState, useEffect, useRef } from 'react';
import './Home.css';
import ServicesSection from '../components/ServicesSection';
import home2 from '../images/home2.jpeg'
import home3 from '../images/stat.jpeg'
import video from '../images/video.mp4'
import { Helmet } from "react-helmet";

function Home() {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeFaq, setActiveFaq] = useState(null);
  const [currentReview, setCurrentReview] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const slides = ['Digital Transformation', 'dApps Services', 'Video Managed Services'];
  const reviews = [
    {
      id: 1,
      name: "Anil Sethi",
      position: "Managing Director",
      company: "Joshua Dean & Co. Ltd., Manchester, UK",
      avatar: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
      rating: 5,
      review:
        "By having them in our team, they play a critical part in our investment company’s efficiency. They have really gained our trust in a short period of time."
    },
    {
      id: 2,
      name: "George Allen",
      position: "Managing Director",
      company: "VP Ekana, New York, USA",
      avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
      rating: 5,
      review:
        "Our fashion brand relies on our back-office team with them. Partnering with them increased our manpower efficiency and really decreased our workload."
    },
    {
      id: 3,
      name: "David",
      position: "Operations Lead",
      company: "Combined Logistics Lines UK Ltd.",
      avatar: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
      rating: 5,
      review:
        "By having them in our team, our logistics company really benefitted. Their teams handle everything effectively and seamlessly."
    },
    {
      id: 4,
      name: "Prakash Tewani",
      position: "President",
      company: "Kaktus, New York, USA",
      avatar: "https://images.unsplash.com/photo-1554151228-14d9def656e4?ixlib=rb-4.0.3&auto=format&fit=crop&w=150&q=80",
      rating: 5,
      review:
        "Their impeccable manpower and back-office services ensure seamless operations and contribute to our fashion buying house’s success."
    }
  ];


  // partnership contents and script start
  const [index, setIndex] = useState(1);
  const [transition, setTransition] = useState(true);

  const items = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="8" cy="8" r="3" />
          <path d="M2 21v-1a5 5 0 0 1 10 0v1" />
          <circle cx="17" cy="10" r="3" />
          <path d="M14 21v-1a4 4 0 0 1 8 0v1" />
        </svg>

      ),
      title: "Single-hire or multi-person teams available",
    },
    {
      icon: (
       <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="7" r="3" />
  <path d="M5 21v-1a7 7 0 0 1 14 0v1" />
  <path d="M16 3h4v6h-4z" />
  <path d="M16 3l2 2 2-2" />
</svg>


      ),
      title: "Dedicated team members (not shared across clients)",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 4h12l4 4v12H4z" />
          <path d="M16 4v4h4" />
          <path d="M7 12l2 2 4-4" />
          <path d="M7 16h6" />
        </svg>

      ),
      title: "Trained in your workflows before day one",
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 3l7 4v5c0 5-3.5 9-7 9s-7-4-7-9V7l7-4z" />
          <path d="M9 12l2 2 4-4" />
        </svg>

      ),
      title: "Predictable performance and reliability",
    },
  ];

  // CLONED ITEMS FOR INFINITE LOOP
  const extendedItems = [
    items[items.length - 1],
    ...items,
    items[0],
  ];

  // RESPONSIVE CARDS PER VIEW
  const getCardsPerView = () => {
    if (window.innerWidth > 1024) return 3;
    if (window.innerWidth > 768) return 2;
    return 1;
  };

  const [cardsPerView, setCardsPerView] = useState(getCardsPerView());

  useEffect(() => {
    const handleResize = () => setCardsPerView(getCardsPerView());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // AUTOPLAY
  useEffect(() => {
    const auto = setInterval(() => {
      setIndex((prev) => prev + 1);
    }, 2500);
    return () => clearInterval(auto);
  }, []);

  // LOOP FIX (SEAMLESS JUMP)
  useEffect(() => {
    if (index === extendedItems.length - 1) {
      setTimeout(() => {
        setTransition(false);
        setIndex(1);
      }, 300);

      setTimeout(() => setTransition(true), 350);
    }

    if (index === 0) {
      setTimeout(() => {
        setTransition(false);
        setIndex(items.length);
      }, 300);

      setTimeout(() => setTransition(true), 350);
    }
  }, [index]);

  // partnership slider end 

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [slides.length]);

  useEffect(() => {
    const reviewInterval = setInterval(() => {
      setCurrentReview((prev) => (prev + 1) % reviews.length);
    }, 4000);

    return () => clearInterval(reviewInterval);
  }, [reviews.length]);

  // Handle window resize for responsive behavior
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto-slide for industries section
  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % 6); // 6 total slides
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(slideInterval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };



  const handleReviewDotClick = (index) => {
    setCurrentReview(index);
  };



  return (
    <div className="home">
      <Helmet>
        <title>Staffing Support India</title>
        <meta name="description" content="Best staffing solutions in India." />
      </Helmet>
      {/* Hero Section with Video */}
      <section className="hero-section">
        <div className="hero-video-container">
          <video autoPlay muted loop playsInline className="hero-video">
            <source src={video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          {/* <div className="hero-overlay"></div> */}
        </div>


      </section>

      <section className="home-about-section">
        <div className="container">
          <div className="home-about-container">
            <div className="home-about-left">
              <div className="home-about-image">
                <img src={home2} alt="Business Innovation" />
                {/* <div className="home-image-overlay">
                  <div className="home-overlay-content">
                    <span className="home-overlay-text">700+ Minds</span>
                    <span className="home-overlay-subtext">11 Countries</span>
                  </div>
                </div> */}
              </div>
              {/* <div className="home-about-features">
                <div className="home-feature-item">
                  <div className="home-feature-icon">🚀</div>
                  <span>Innovation-Driven Solutions</span>
                </div>
                <div className="home-feature-item">
                  <div className="home-feature-icon">🌍</div>
                  <span>Global Expertise</span>
                </div>

              </div> */}
            </div>

            <div className="home-about-right">
              <h2
                style={{
                  textTransform: "capitalize"
                }}
              >Save 70% on Employee Payroll With Dedicated Offshore Teams</h2>

              <p className="home-about-subtitle">At SSI, we handpick the right person for your role.</p>

              <p className="home-about-description">
                Unlike traditional outsourcing platforms that assign part-time or shared resources, Staffing Support India handpicks and hires full-time professionals dedicated exclusively to your business. Your offshore team works like in-house employees—understanding your business,
                following your processes, and growing with your company—but from our Delhi office.

                {/* <h5>What Makes Our Model Different:</h5>
                  <ul>
                    <li>Single-hire or multi-person teams available</li>
                    <li>Full-time commitment (no part-time splits)</li>
                    <li>Trained in your workflows before day one</li>
                    <li>Predictable performance and reliability</li>
                  </ul> */}
              </p>




            </div>
          </div>
        </div>
      </section>
      {/* Stats Section */}


      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              Our Professional <span className="highlight">Services</span>
            </h2>
            <p className="section-subtitle">
              We provide dedicated offshore professionals across 12+ roles—marketing, finance, data, and support—for <b> North American, UK, and Australian</b> businesses. Whether you need one virtual assistant or a full back-office team, SSI delivers vetted Indian talent trained to your requirements.
            </p>
          </div>

          <div className="services-grid">
            <div
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('cad')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)' }}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="24" height="24" stroke="currentColor" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="12" rx="1" />
                    <path d="M8 18h8" />
                    <path d="M12 7v5" />
                    <path d="M9 10h6" />
                    <path d="M3 20h18" />
                  </svg>
                </div>
                <h3>CAD Designers</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'cad' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Create accurate, detailed garment and product designs</li>
                    <li><span className="checkmark">✓</span> Work with global fashion teams on seasonal collections</li>
                    <li><span className="checkmark">✓</span> Ensure production-ready designs for sampling & manufacturing</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('merchandisers')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)' }}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12,18H6V14H12M21,14V12L20,7H4L3,12V14H4V20H14V14H18V20H20V14M12,10H6V6H12V10Z" />
                  </svg>
                </div>
                <h3>Merchandisers</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'merchandisers' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Coordinate between design, production, and buyers</li>
                    <li><span className="checkmark">✓</span> Manage product development timelines & sourcing</li>
                    <li><span className="checkmark">✓</span> Track orders and ensure on-time delivery</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('social')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)' }}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H12V9.5H18M5,10V14H11V10M12,11V15H18V11M5,15V19H11V15M12,16V20H18V16M5,5V9H11V5H5Z" />
                  </svg>
                </div>
                <h3>Social Media </h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'social' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Plan and execute campaigns across platforms</li>
                    <li><span className="checkmark">✓</span> Engage audiences and build brand presence</li>
                    <li><span className="checkmark">✓</span> Analyze performance metrics for growth</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('graphic')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1561070791-2526d30994b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)' }}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12,2A2,2 0 0,1 14,4V8L15,7L16,8V4A2,2 0 0,1 18,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H18A2,2 0 0,1 16,16V12L15,13L14,12V16A2,2 0 0,1 12,18H4A2,2 0 0,1 2,16V4A2,2 0 0,1 4,2H12M4,4V16H12V4H4M18,4V16H20V4H18Z" />
                  </svg>
                </div>
                <h3>Graphic Designers</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'graphic' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Design visuals for digital & print campaigns</li>
                    <li><span className="checkmark">✓</span> Maintain brand consistency across creatives</li>
                    <li><span className="checkmark">✓</span> Collaborate with marketing and product teams</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('marketing')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)' }}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,12L13.41,16L19.71,9.71L22,12V6H16Z" />
                  </svg>
                </div>
                <h3>Product Marketing </h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'marketing' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Assist in product launches and campaigns</li>
                    <li><span className="checkmark">✓</span> Conduct competitor and market analysis</li>
                    <li><span className="checkmark">✓</span> Support cross-functional marketing initiatives</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('digital')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)' }}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="8" />
                    <circle cx="12" cy="12" r="4" />
                    <path d="M12 2v2" />
                    <path d="M12 20v2" />
                    <path d="M2 12h2" />
                    <path d="M20 12h2" />
                    <path d="M15 9l6-6" />
                    <path d="M21 3v4h-4" />
                  </svg>
                </div>
                <h3>Digital Marketers</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'digital' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Manage SEO, SEM, and paid ad campaigns</li>
                    <li><span className="checkmark">✓</span> Optimize websites and landing pages for conversions</li>
                    <li><span className="checkmark">✓</span> Track KPIs and improve campaign performance</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('accounting')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)' }}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                  </svg>
                </div>
                <h3>US/UK Accountants</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'accounting' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Handle bookkeeping, reconciliations, and reporting</li>
                    <li><span className="checkmark">✓</span> Prepare P&L, balance sheets, and cash flow statements</li>
                    <li><span className="checkmark">✓</span> Ensure compliance with US/UK accounting standards</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('ecommerce')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)' }}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17,18C17.5,18 18,18.4 18,19A2,2 0 0,1 16,21H8A2,2 0 0,1 6,19C6,18.4 6.4,18 7,18H17M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5H5.21L4.27,3H1Z" />
                  </svg>
                </div>
                <h3>E-commerce </h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'ecommerce' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Oversee product listings, pricing, and inventory</li>
                    <li><span className="checkmark">✓</span> Manage online sales channels (Amazon, Shopify, etc.)</li>
                    <li><span className="checkmark">✓</span> Improve customer experience and online revenue</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('voice')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1553484771-371a605b060b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)' }}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
                  </svg>
                </div>
                <h3>Voice Sales Associates</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'voice' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Handle inbound/outbound calls for US/UK clients</li>
                    <li><span className="checkmark">✓</span> Build and maintain customer relationships</li>
                    <li><span className="checkmark">✓</span> Drive sales through effective communication</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('content')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1455390582262-044cdead277a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)' }}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                  </svg>
                </div>
                <h3>Content Writers</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'content' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> SEO-Optimized Content</li>
                    <li><span className="checkmark">✓</span> Blog & Article Writing</li>
                    <li><span className="checkmark">✓</span> Website Copy Creation</li>
                    <li><span className="checkmark">✓</span> Technical Documentation</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('data')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)' }}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M22,21H2V3H4V19H6V10H10V19H12V6H16V19H18V14H22V21Z" />
                  </svg>
                </div>
                <h3>Data Analysts</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'data' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Business Intelligence</li>
                    <li><span className="checkmark">✓</span> Statistical Analysis</li>
                    <li><span className="checkmark">✓</span> Data Visualization</li>
                    <li><span className="checkmark">✓</span> Predictive Modeling</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div
              className="home-service-card"
              onMouseEnter={() => setHoveredCard('virtual')}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="home-service-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80)' }}></div>
              <div className="home-service-overlay"></div>
              <div className="home-service-content">
                <div className="home-service-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z" />
                  </svg>
                </div>
                <h3>Virtual Assistants</h3>
                <div className="home-service-divider"></div>
                <div className={`home-service-details ${hoveredCard === 'virtual' ? 'visible' : ''}`}>
                  <ul>
                    <li><span className="checkmark">✓</span> Administrative Support</li>
                    <li><span className="checkmark">✓</span> Calendar Management</li>
                    <li><span className="checkmark">✓</span> Email Management</li>
                    <li><span className="checkmark">✓</span> Research & Documentation</li>
                  </ul>
                  <button className="home-learn-more-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>
                    Learn More
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* <div className="why-choose-section">
        <div className="container">
          <div className="text-center mb-16">
            <h2 className="services-section-title section-title">
              Why Choose Our Services?
            </h2>
            <p className="services-section-subtitle">
              We combine expertise, technology, and dedication to deliver exceptional results
            </p>
          </div>

          <div className="why-choose-grid">
            <div className="why-choose-item">
              <div className="why-choose-icon fast-results">
                <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="why-choose-title">Fast Results</h3>
              <p className="why-choose-description">Quick turnaround times with immediate impact on your business</p>
            </div>

            <div className="why-choose-item">
              <div className="why-choose-icon proven-track">
                <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="why-choose-title">Quality Assured</h3>
              <p className="why-choose-description">Rigorous quality control processes ensure consistent, high-standard service delivery</p>
            </div>

            <div className="why-choose-item">
              <div className="why-choose-icon expert-team"
                            style={{background: '#F39C12'}}

              >
                <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                </svg>
              </div>
              <h3 className="why-choose-title">Cost Effective</h3>
              <p className="why-choose-description">Competitive pricing with transparent costs and excellent return on investment</p>
            </div>

        
          </div>
        </div>
      </div> */}
      <section className="industries-section">
        <div className="container">
          <ServicesSection />

          {/* <div className="industries-container">
            <div className="industries-left">
              <h2>Industries We Serve</h2>
              <p className="industries-subtitle">Specialized Teams. Global Expertise.</p>
              <p className="industries-description">
                From fashion and e-commerce to finance and technology, our skilled professionals deliver exceptional results across diverse industries with precision and innovation.
              </p>

            </div>

            <div className="industries-right">
              <div className="industries-slider-container">
                <div className="industries-slider" style={{ transform: `translateX(-${currentSlide * 14.28}%)` }}>
                  <div className="industry-slide">
                    <div className="industry-card modern" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80)' }}>
                      <div className="card-overlay">
                        <div className="card-icon">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12,2A2,2 0 0,1 14,4V8A2,2 0 0,1 12,10A2,2 0 0,1 10,8V4A2,2 0 0,1 12,2M21,9V7H3V9H21M21,16V10H3V16H21M21,21V18H3V21H21Z" />
                          </svg>
                        </div>
                        <h3>Fashion</h3>
                        <p>From apparel brands to global sourcing companies, we support fashion businesses with design, merchandising, and operational teams who understand seasonal trends and retail dynamics.</p>
                        <div className="common-roles">
                          <strong>Common Roles:</strong> CAD designers, merchandisers, sales coordinators, product data managers, customer support executives.
                        </div>
                        <button className="industry-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>Get Started</button>
                      </div>
                    </div>
                  </div>

                  <div className="industry-slide">
                    <div className="industry-card modern" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80)' }}>
                      <div className="card-overlay">
                        <div className="card-icon">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z" />
                          </svg>
                        </div>
                        <h3>Healthcare</h3>
                        <p>We help healthcare providers and businesses streamline administrative tasks, ensuring smoother patient and back-office management.</p>
                        <div className="common-roles">
                          <strong>Common Roles:</strong> Medical billing specialists, insurance coordinators, patient support representatives, data entry executives.
                        </div>
                        <button className="industry-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>Get Started</button>
                      </div>
                    </div>
                  </div>

                  <div className="industry-slide">
                    <div className="industry-card modern" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1596462502278-27bfdc403348?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80)' }}>
                      <div className="card-overlay">
                        <div className="card-icon">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z" />
                          </svg>
                        </div>
                        <h3>Cosmetics</h3>
                        <p>For beauty and personal care brands, we provide sales, marketing, and back-office teams who help manage day-to-day operations and customer outreach.</p>
                        <div className="common-roles">
                          <strong>Common Roles:</strong> E-commerce coordinators, social media executives, customer support agents, product catalog managers.
                        </div>
                        <button className="industry-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>Get Started</button>
                      </div>
                    </div>
                  </div>

                  <div className="industry-slide">
                    <div className="industry-card modern" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80)' }}>
                      <div className="card-overlay">
                        <div className="card-icon">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M3,4H7V8H3V4M9,5V7H21V5H9M3,10H7V14H3V10M9,11V13H21V11H9M3,16H7V20H3V16M9,17V19H21V17H9" />
                          </svg>
                        </div>
                        <h3>Logistics</h3>
                        <p>Our teams help logistics companies optimize shipment tracking, documentation, and customer communication, supporting global freight and supply chain operations.</p>
                        <div className="common-roles">
                          <strong>Common Roles:</strong> Documentation specialists, tracking coordinators, operations executives, customer service reps.
                        </div>
                        <button className="industry-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>Get Started</button>
                      </div>
                    </div>
                  </div>

                  <div className="industry-slide">
                    <div className="industry-card modern" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80)' }}>
                      <div className="card-overlay">
                        <div className="card-icon">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M13,13V7H11V13H13M13,17V15H11V17H13Z" />
                          </svg>
                        </div>
                        <h3>Finance</h3>
                        <p>We build strong finance teams that handle accounting and reporting with accuracy, helping companies manage books without hiring in-house.</p>
                        <div className="common-roles">
                          <strong>Common Roles:</strong> US accountants, bookkeepers, accounts payable/receivable specialists, financial reporting associates.
                        </div>
                        <button className="industry-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>Get Started</button>
                      </div>
                    </div>
                  </div>

                  <div className="industry-slide">
                    <div className="industry-card modern" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80)' }}>
                      <div className="card-overlay">
                        <div className="card-icon">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19,7H11V14H19V7M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3H19M5,5V19H19V5H5Z" />
                          </svg>
                        </div>
                        <h3>Hospitality</h3>
                        <p>From guest experience to back-end management, we provide dedicated teams for hotels, travel companies, and hospitality brands to keep operations running smoothly.</p>
                        <div className="common-roles">
                          <strong>Common Roles:</strong> Reservation specialists, virtual concierges, guest relations executives, sales support associates.
                        </div>
                        <button className="industry-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>Get Started</button>
                      </div>
                    </div>
                  </div>

                  <div className="industry-slide">
                    <div className="industry-card modern expanding" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80)' }}>
                      <div className="card-overlay">
                        <div className="card-icon">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z" />
                          </svg>
                        </div>
                        <h3>& Expanding</h3>
                        <p>We're constantly growing into new industries — if your business needs a team, we can build it.</p>
                        <div className="common-roles">
                          <strong>Your Industry Next:</strong> Contact us to discuss your specific industry requirements and team needs.
                        </div>
                        <button className="industry-btn" onClick={() => window.open('https://wa.me/918076090700', '_blank')}>Get Started</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="slider-dots">
                  {[0, 1, 2, 3, 4, 5, 6].map((index) => (
                    <span
                      key={index}
                      className={`dot ${currentSlide === index ? 'active' : ''}`}
                      onClick={() => handleDotClick(index)}
                    ></span>
                  ))}
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </section>

      {/* About Section */}


      {/* Partnership Section */}
      <section className="partnership-section">
        <div className="container">

          {/* Header */}
          <div className="section-header">
            <h2 className="section-title">
              Partnering for <span className="highlight">Success</span>
            </h2>
            <p className="section-subtitle">What Makes Our Model Different</p>
          </div>

          {/* Slider */}
          <div className="partnership-slider-container">
            <div
              className="partnership-slider-track"
              style={{
                width: `${extendedItems.length * (100 / cardsPerView)}%`,
                transform: `translateX(-${(index * 100) / extendedItems.length}%)`,
                transition: transition ? "0.4s ease" : "none",
                display: "flex",
              }}
            >
              {extendedItems.map((item, i) => (
                <div
                  key={i}
                  className="partnership-card"
                  style={{ width: `${100 / cardsPerView}%` }}
                >
                  <div className="partnership-icon">{item.icon}</div>
                  <h3>{item.title}</h3>
                </div>
              ))}
            </div>

            {/* DOTS */}
            <div className="partnership-dots">
              {items.map((_, dotIndex) => (
                <span
                  key={dotIndex}
                  className={`dot ${index - 1 === dotIndex ? "active" : ""}`}
                  onClick={() => setIndex(dotIndex + 1)}
                ></span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <div className="cta-text">
              <h2>Ready to Transform Your Business?</h2>
              <p>From a single role to fully functional offshore teams — we help you scale with ease and precision</p>
              <div className="cta-stats">
                <div className="stat-item">
                  <span className="stat-number">20+ </span>
                  <span className="stat-label">Global Roles Delivered</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">1,00,000+ </span>
                  <span className="stat-label">Hours Logged Remotely</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">100% </span>
                  <span className="stat-label">Client Retention So Far</span>
                </div>
              </div>
              <div className="cta-buttons">
                <a href="/contact">   <button className="btn btn-primary">Get Started Now</button></a>
                {/* <button className="btn btn-secondary">Schedule Consultation</button> */}
              </div>
            </div>
            <div className="cta-image">
              <img src={home3} alt="Professional Team" />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="home-faq-section">
        <div className="container">
          <div className="home-faq-container">
            <div className="home-faq-left">
              <h2>Have Questions?</h2>
              <p className="home-faq-subtitle">We're Here to Help</p>
              <p className="home-faq-description">
                Our team is dedicated to making your offshore staffing journey as smooth and successful as possible. Whether you're just exploring or ready to start, feel free to ask — no question is too small.
              </p>
              <div className="home-contact-info">
                <div className="home-contact-item">
                  <div className="home-contact-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z" />
                    </svg>
                  </div>
                  <div>
                    <span className="home-contact-label">Call Us</span>
                    <span className="home-contact-value">+91 8076090700</span>
                  </div>
                </div>
                <div className="home-contact-item">
                  <div className="home-contact-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
                    </svg>
                  </div>
                  <div>
                    <span className="home-contact-label">Email Us</span>
                    <span className="home-contact-value">info@staffingsupportindia.com
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="home-faq-right">
              <div className="home-faq-list">
                <div className="home-faq-item">
                  <div className="home-faq-question" onClick={() => toggleFaq(0)}>
                    <h4>What services do you offer?</h4>
                    <span className="home-faq-toggle">{activeFaq === 0 ? '-' : '+'}</span>
                  </div>
                  <div className={`home-faq-answer ${activeFaq === 0 ? 'active' : ''}`}>
                    <p> We offer offshore staffing solutions for roles across fashion, healthcare, finance, logistics, and more - Including Tele-sales, Graphic design, CAD, Bookkeeping, Marketing, and E-commerce operations.</p>
                  </div>
                </div>

                <div className="home-faq-item">
                  <div className="home-faq-question" onClick={() => toggleFaq(1)}>
                    <h4> How do I know if my company is a fit for offshore staffing?
                    </h4>
                    <span className="home-faq-toggle">{activeFaq === 1 ? '-' : '+'}</span>
                  </div>
                  <div className={`home-faq-answer ${activeFaq === 1 ? 'active' : ''}`}>
                    <p> If you're looking to reduce costs, expand your team without increasing overhead, or access skilled talent for specific roles - you're a fit. We work with businesses of all sizes, especially small and medium enterprises.
                    </p>
                  </div>
                </div>

                <div className="home-faq-item">
                  <div className="home-faq-question" onClick={() => toggleFaq(2)}>
                    <h4> Will the offshore team be dedicated to me?
                    </h4>
                    <span className="home-faq-toggle">{activeFaq === 2 ? '-' : '+'}</span>
                  </div>
                  <div className={`home-faq-answer ${activeFaq === 2 ? 'active' : ''}`}>
                    <p> Yes, your team members work only for your company. They're not shared resources , they’re like your own employees, just based in India.</p>
                  </div>
                </div>

                <div className="home-faq-item">
                  <div className="home-faq-question" onClick={() => toggleFaq(3)}>
                    <h4>What does SSI handle in the hiring process?</h4>
                    <span className="home-faq-toggle">{activeFaq === 3 ? '-' : '+'}</span>
                  </div>
                  <div className={`home-faq-answer ${activeFaq === 3 ? 'active' : ''}`}>
                    <p> We handle everything - from shortlisting and interviews to onboarding and compliance. You make the final selection, and we take care of the rest so you can focus on growth.
                    </p>
                  </div>
                </div>

                <div className="home-faq-item">
                  <div className="home-faq-question" onClick={() => toggleFaq(4)}>
                    <h4>How flexible is the engagement model?
                    </h4>
                    <span className="home-faq-toggle">{activeFaq === 4 ? '-' : '+'}</span>
                  </div>
                  <div className={`home-faq-answer ${activeFaq === 4 ? 'active' : ''}`}>
                    <p>Whether you want to start with one person or an entire team, we adapt to your needs. Scale up or down anytime depending on your project and budget..</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="reviews-section">
        <div className="container">
          <div className="reviews-header">
            <h2>Hear from clients who scaled faster with SSI </h2>
            <p className="reviews-subtitle">Real stories from North America, the UK, and Australia; built on trust and outcomes.</p>
          </div>

          <div className="reviews-slider-container">
            <div className="reviews-slider" style={{ transform: `translateX(-${currentReview * 100}%)` }}>
              {reviews.map((review, index) => (
                <div key={review.id} className="review-slide">
                  <div className="review-card">
                    <div className="review-content">
                      <div className="review-stars">
                        {[...Array(review.rating)].map((_, i) => (
                          <span key={i} className="star">★</span>
                        ))}
                      </div>
                      <p className="review-text">"{review.review}"</p>
                    </div>
                    <div className="review-author">
                      {/* <div className="author-avatar">
                        <img src={review.avatar} alt={review.name} />
                      </div> */}
                      <div className="author-info">
                        <h4 className="author-name">{review.name}</h4>
                        <p className="author-position">{review.position}</p>
                        <p className="author-company">{review.company}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="reviews-dots">
              {reviews.map((_, index) => (
                <button
                  key={index}
                  className={`review-dot ${currentReview === index ? 'active' : ''}`}
                  onClick={() => handleReviewDotClick(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;